import { Prisma } from '@prisma/client'
import { FunctionalComponent } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import { GetServerSideProps } from '../../server-middleware/context'
import { z } from 'zod'
import LastVisitors from '../widget-last-visitors/LastVisitors.sync'
import classnames from 'classnames'

export const widgetName = 'statistics_bar'

export const config = z.object({
  total_topics: z.boolean().optional(),
  total_comments: z.boolean().optional(),
  total_users: z.boolean().optional()
})

interface Statistics {
  reactiontotal: number
  membertotal: number
  topictotal: number
}

type QueryResult = Array<{statistic: string, total: string}>

export const getServerSideProps: GetServerSideProps<z.infer<typeof config>, Statistics> = async (context, config) => {
  const statistics = {
    reactiontotal: 0,
    membertotal: 0,
    topictotal: 0
  }

  const rows = await context.cache('community-stats', () => context.prismaClient.$queryRaw<QueryResult>(Prisma.sql`SELECT statistic, total FROM statistics`))

  for (const row of rows) {
    switch (row.statistic) {
      case 'reactions':
        if (config.total_comments === false) break
        statistics.reactiontotal = parseInt(row.total)
        break
      case 'members':
        if (config.total_users === false) break
        statistics.membertotal = parseInt(row.total)
        break
      case 'topics':
        if (config.total_topics === false) break
        statistics.topictotal = parseInt(row.total)
        break
    }
  }

  return statistics
}

const CommunityStatisticsWidget: FunctionalComponent<Statistics> = (props: Statistics) => {
  return (
    <section className={classnames('full-width', 'Template-brand-stats', 'custom-stats-bar')}>
      <div className={classnames('stats-bar', 'p-v', 'qa-stats-bar')}>
        <div className='sitewidth'>
          <div className='col'>
            <ul className={classnames('list', 'list--stats-bar', 'qa-stats-bar')}>
              <li className='list__item'>
                <strong>{props.topictotal.toLocaleString()} </strong>
                <span><Phrase p='Topic|Topics' /></span>
              </li>
              <li className='list__item'>
                <strong>{props.reactiontotal.toLocaleString()} </strong>
                <span><Phrase p='Reply|Replies' /></span>
              </li>
              <li className='list__item'>
                <strong>{props.membertotal.toLocaleString()} </strong>
                <span><Phrase p='Members' /></span>
              </li>
            </ul>

            <div id='last-visitors-widget' className={classnames('last-visitors', 'qa-last-visitors', 'is-hidden-M', 'pull-right')}>
              <LastVisitors />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CommunityStatisticsWidget
